import { formatDate } from "../utils/dates";
import { ParticipantWithId } from "../interfaces/IParticipants";
import { useMemo, useState } from "react";

/**
 * Hook do wyszukiwania zawodników
 * Zgodny z zasadą pojedynczej odpowiedzialności - tylko logika wyszukiwania
 */
export const useParticipantsSearch = (participants: ParticipantWithId[]) => {
  const [searchTerm, setSearchTerm] = useState("");

  // Filtrowanie zawodników na podstawie wyszukiwania
  const filteredParticipants = useMemo(() => {
    if (!searchTerm.trim()) {
      return participants;
    }

    const term = searchTerm.toLowerCase().trim();

    return participants.filter((participant) => {
      const firstName = participant.firstName?.toLowerCase() || "";
      const lastName = participant.lastName?.toLowerCase() || "";
      const birthDate = formatDate(participant.birthDate).toLowerCase();

      return firstName.includes(term) || lastName.includes(term) || birthDate.includes(term);
    });
  }, [participants, searchTerm]);

  return {
    searchTerm,
    setSearchTerm,
    filteredParticipants,
  };
};
